/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemTranslationRequestDto } from '../../models/item-translation-request-dto';

export interface ItemSetTranslations$Params {
  itemId: string;
      body?: Array<ItemTranslationRequestDto>
}

export function itemSetTranslations(http: HttpClient, rootUrl: string, params: ItemSetTranslations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, itemSetTranslations.PATH, 'post');
  if (params) {
    rb.path('itemId', params.itemId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

itemSetTranslations.PATH = '/api/Item/{itemId}/translation/set-many';
